import * as React from 'react';
import { ChangeEventHandler, FocusEventHandler, FocusEvent, ChangeEvent, useEffect } from 'react';

import { UseState } from '../../types';

import { Container, Input, SearchInputContainer, InputLabel } from './searchInput.styled';
import { SearchInputProps } from './searchInput.types';

export const SearchInput: React.FC<SearchInputProps> = (props: SearchInputProps): JSX.Element => {
  const { placeholder, value, inputLabel, disabled, onBlur, onChange, onKeyPress, className }: SearchInputProps = props;
  const [inputValue, setInputValue]: UseState<string | undefined> = React.useState<string | undefined>(value);
  const name: string | undefined = placeholder?.replace(/\ /g, '').toLowerCase();

  useEffect((): void => setInputValue(value), [value]);

  const onChangeAction: ChangeEventHandler<HTMLInputElement> = (e: ChangeEvent<HTMLInputElement>): void => {
    const valueFromEvent: string = e.target.value;
    if (onChange) {
      onChange(valueFromEvent);
    }
    setInputValue(valueFromEvent);
  };

  const onBlurAction: FocusEventHandler<HTMLInputElement> = (e: FocusEvent<HTMLInputElement, Element>): void => {
    const valueFromEvent: string = e.target.value;
    if (onBlur) {
      onBlur(valueFromEvent);
    }
  };

  return (
    <Container className={className}>
      <SearchInputContainer>
        <Input
          id={name}
          name={name}
          disabled={disabled}
          value={inputValue}
          onChange={onChangeAction}
          onBlur={onBlurAction}
          onKeyPress={onKeyPress}
          placeholder={placeholder}
          data-testid='search-input'
          autoFocus
        />
        {!!inputLabel && <InputLabel>{inputLabel}</InputLabel>}
      </SearchInputContainer>
    </Container>
  );
};
